module.exports = __webpack_public_path__ + "static/nauticalmain-9064aa410c133ae8b8c2eeaa8ab7573a.png";